import { mainLocator as locator } from '@core/di/main.locator';
import { UiService } from '@core/services/ui.services';
import { UserRepository } from '@modules/administration/pages/users/user.repository';
import { UserStore } from '@modules/administration/pages/users/user.store';

locator.register('UserRepository', UserRepository);
locator.registerInstance(
  'UserStore',
  new UserStore(
    locator.resolve<UiService>('UiService'),
    locator.resolve<UserRepository>('UserRepository'),
  ),
);
